import { checker, validator } from 'common/utils/validator'
import { isEmailValid, isNotEmpty } from 'src/shared/utils/field-validators'

export const validateEmptyField = checker(
  validator('validation.not_empty', isNotEmpty),
)

export const validateEmailField = checker(
  validator('validation.email_invalid', isEmailValid),
)
